/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _homepage_banner_text_fr = new IntlMessageFormat(
    [{ type: 0, value: "Votre réseau [b]d'opportunités professionnelles[/b] %ap%" }],
    'fr',
);

const _homepage_banner_text_en = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Your network of [b]professional opportunities[/b] of %country%',
        },
    ],
    'en',
);

export function homepage_banner_text(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _homepage_banner_text_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _homepage_banner_text_en.format(args) as unknown as string;
    }

    return _homepage_banner_text_fr.format(args) as unknown as string;
}

const _placeholder_whatwho_company_fr = new IntlMessageFormat(
    [{ type: 0, value: "Nom d'une société, d'un secteur d'activité..." }],
    'fr',
);

const _placeholder_whatwho_company_en = new IntlMessageFormat(
    [{ type: 0, value: 'Company name, industry...' }],
    'en',
);

export function placeholder_whatwho_company(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _placeholder_whatwho_company_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _placeholder_whatwho_company_en.format(args) as unknown as string;
    }

    return _placeholder_whatwho_company_fr.format(args) as unknown as string;
}

const _placeholder_whatwho_pro_fr = new IntlMessageFormat(
    [{ type: 0, value: "Nom et prénom d'un professionnel, secteur d'activité..." }],
    'fr',
);

const _placeholder_whatwho_pro_en = new IntlMessageFormat(
    [{ type: 0, value: "Professional's first and last name, industry..." }],
    'en',
);

export function placeholder_whatwho_pro(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _placeholder_whatwho_pro_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _placeholder_whatwho_pro_en.format(args) as unknown as string;
    }

    return _placeholder_whatwho_pro_fr.format(args) as unknown as string;
}

const _placeholder_whatwho_newsfeed_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Recherche libre...' }],
    'fr',
);

const _placeholder_whatwho_newsfeed_en = new IntlMessageFormat(
    [{ type: 0, value: 'Free search...' }],
    'en',
);

export function placeholder_whatwho_newsfeed(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _placeholder_whatwho_newsfeed_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _placeholder_whatwho_newsfeed_en.format(args) as unknown as string;
    }

    return _placeholder_whatwho_newsfeed_fr.format(args) as unknown as string;
}

const _placeholder_whatwho_job_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Intitulé du poste recherché (exemple : serveur, garagiste, commercial...)',
        },
    ],
    'fr',
);

const _placeholder_whatwho_job_en = new IntlMessageFormat(
    [{ type: 0, value: 'Job title (example: waiter, mechanic, salesperson...)' }],
    'en',
);

export function placeholder_whatwho_job(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _placeholder_whatwho_job_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _placeholder_whatwho_job_en.format(args) as unknown as string;
    }

    return _placeholder_whatwho_job_fr.format(args) as unknown as string;
}

const _label_whatwho_company_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Qui, Quoi ?' }],
    'fr',
);

const _label_whatwho_company_en = new IntlMessageFormat(
    [{ type: 0, value: 'Who, What?' }],
    'en',
);

export function label_whatwho_company(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _label_whatwho_company_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _label_whatwho_company_en.format(args) as unknown as string;
    }

    return _label_whatwho_company_fr.format(args) as unknown as string;
}

const _label_whatwho_pro_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Qui, Quoi ?' }],
    'fr',
);

const _label_whatwho_pro_en = new IntlMessageFormat(
    [{ type: 0, value: 'Who, What?' }],
    'en',
);

export function label_whatwho_pro(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _label_whatwho_pro_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _label_whatwho_pro_en.format(args) as unknown as string;
    }

    return _label_whatwho_pro_fr.format(args) as unknown as string;
}

const _label_whatwho_newsfeed_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Qui, Quoi ?' }],
    'fr',
);

const _label_whatwho_newsfeed_en = new IntlMessageFormat(
    [{ type: 0, value: 'Who, What?' }],
    'en',
);

export function label_whatwho_newsfeed(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _label_whatwho_newsfeed_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _label_whatwho_newsfeed_en.format(args) as unknown as string;
    }

    return _label_whatwho_newsfeed_fr.format(args) as unknown as string;
}

const _label_whatwho_job_fr = new IntlMessageFormat([{ type: 0, value: 'Poste' }], 'fr');

const _label_whatwho_job_en = new IntlMessageFormat(
    [{ type: 0, value: 'Job title' }],
    'en',
);

export function label_whatwho_job(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _label_whatwho_job_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _label_whatwho_job_en.format(args) as unknown as string;
    }

    return _label_whatwho_job_fr.format(args) as unknown as string;
}

const _label_hashtag_fr = new IntlMessageFormat([{ type: 0, value: 'Hashtag' }], 'fr');

const _label_hashtag_en = new IntlMessageFormat([{ type: 0, value: 'Hashtag' }], 'en');

export function label_hashtag(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _label_hashtag_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _label_hashtag_en.format(args) as unknown as string;
    }

    return _label_hashtag_fr.format(args) as unknown as string;
}

const _placeholder_hashtag_fr = new IntlMessageFormat([{ type: 0, value: '#' }], 'fr');

const _placeholder_hashtag_en = new IntlMessageFormat([{ type: 0, value: '#' }], 'en');

export function placeholder_hashtag(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _placeholder_hashtag_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _placeholder_hashtag_en.format(args) as unknown as string;
    }

    return _placeholder_hashtag_fr.format(args) as unknown as string;
}

const _label_where_fr = new IntlMessageFormat([{ type: 0, value: 'Où ?' }], 'fr');

const _label_where_en = new IntlMessageFormat([{ type: 0, value: 'Where ?' }], 'en');

export function label_where(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _label_where_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _label_where_en.format(args) as unknown as string;
    }

    return _label_where_fr.format(args) as unknown as string;
}

const _placeholder_where_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Pays, ville...' }],
    'fr',
);

const _placeholder_where_en = new IntlMessageFormat(
    [{ type: 0, value: 'Country, city...' }],
    'en',
);

export function placeholder_where(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _placeholder_where_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _placeholder_where_en.format(args) as unknown as string;
    }

    return _placeholder_where_fr.format(args) as unknown as string;
}

const _type_tab_company_fr = new IntlMessageFormat([{ type: 0, value: 'Société' }], 'fr');

const _type_tab_company_en = new IntlMessageFormat([{ type: 0, value: 'Company' }], 'en');

export function type_tab_company(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _type_tab_company_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _type_tab_company_en.format(args) as unknown as string;
    }

    return _type_tab_company_fr.format(args) as unknown as string;
}

const _type_tab_pro_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Professionnels' }],
    'fr',
);

const _type_tab_pro_en = new IntlMessageFormat(
    [{ type: 0, value: 'Professionals' }],
    'en',
);

export function type_tab_pro(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _type_tab_pro_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _type_tab_pro_en.format(args) as unknown as string;
    }

    return _type_tab_pro_fr.format(args) as unknown as string;
}

const _type_tab_newsfeed_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Réseaux' }],
    'fr',
);

const _type_tab_newsfeed_en = new IntlMessageFormat(
    [{ type: 0, value: 'Networks' }],
    'en',
);

export function type_tab_newsfeed(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _type_tab_newsfeed_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _type_tab_newsfeed_en.format(args) as unknown as string;
    }

    return _type_tab_newsfeed_fr.format(args) as unknown as string;
}

const _type_tab_job_fr = new IntlMessageFormat([{ type: 0, value: 'Emplois' }], 'fr');

const _type_tab_job_en = new IntlMessageFormat([{ type: 0, value: 'Jobs' }], 'en');

export function type_tab_job(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _type_tab_job_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _type_tab_job_en.format(args) as unknown as string;
    }

    return _type_tab_job_fr.format(args) as unknown as string;
}
